import BaseRepository from "../../../lib/itn-ui-kit/services/repositories/base-repository";
import ReachableContactModel from "../../models/reachable-contact";

export default class ReachableContactRepository extends BaseRepository {
  static modelClass = ReachableContactModel;
  modelName = "reachable-contact";
}
